// extracted by mini-css-extract-plugin
export default {"container":"_37W7v"};